const TOTAL_SPACES_NAME = 'TOTAL';

const datetimeFormatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
};

const CANVAS_SHORT_WIDTH = 300;
const CANVAS_LONG_WIDTH = 386;
const CANVAS_LINE_HEIGHT = 18;

export { TOTAL_SPACES_NAME, datetimeFormatOptions, CANVAS_LINE_HEIGHT, CANVAS_LONG_WIDTH, CANVAS_SHORT_WIDTH };
